export default __webpack_public_path__ + "static/media/img_shop-product01.f6a377c0.png";